module.exports = __webpack_public_path__ + "static/media/HomeHero.cd180e15.jpg";